import { ReactReportContext } from "@sa/rep-react";
import * as React from "react";
import { LayoutPart } from "@sa/rep-core";

export function useLayoutComponent(componentId: string, layoutId: string = "default"): LayoutPart | undefined {
  const context = React.useContext(ReactReportContext);
  const definition = context.reportContext.definition;
  const layouts = definition.layouts[layoutId];
  return layouts && layouts.find((x) => x.componentId === componentId);
}
